// import React, { useRef, useState } from 'react'
// import BillDetail from '../Modal/BillDetail';
// import DateFormat from './DateFormat';
// import axios from 'axios';
// import { DownloadTableExcel } from 'react-export-table-to-excel';
// import { toast } from 'react-toastify';

// const CustomerHistory = ({
//     customerHistory,
//     discountTotal,
//     totalSum,
//     selectedOutlet,
//     url,
//     token
// }) => {
//     const tableRef = useRef(null);

//     const [billData, setBillData] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [billID, setBillID] = useState();

//     // const [billInfo, setBillInfo] = useState({});
//     // const [billInfoList, setBillInfoList] = useState([]);

//     const handleCloseModal = () => {
//         setShowModal(false);
//     };

//     const convertDate = (date) =>
//         new Date(date).toLocaleDateString("en-CA");

//     const handleBillInfo = async (item) => {
//         const payload = item.idtblorderhistory || item.idtblorderHistory
//             ? {
//                 idtblorderhistory: item.idtblorderhistory || item.idtblorderHistory,
//                 Date: convertDate(item.Date),
//                 Outlet_Name: selectedOutlet,
//                 token: token,
//             }
//             : item.idtblorderhistory
//                 ? {
//                     idtblorderhistory: item.idtblorderhistory,
//                     Date: convertDate(item.Date),
//                     Outlet_Name: selectedOutlet,
//                     token: token,
//                 }
//                 : {
//                     bill_no: item.bill_no,
//                     Date: convertDate(item.Date),
//                     Outlet_Name: selectedOutlet,
//                     token: token,
//                 };

//         try {
//             const { data } = await axios.post(`${url}/billinfo`, payload);

//             setBillData(data || []);
//             setShowModal(true);
//         } catch (error) {
//             console.log("Bill error", error);
//             toast.error(error?.response?.data?.error || "Failed to fetch data for the selected bill")
//         }
//     };

//     // const handleBillInfo = async (item) => {
//     //     console.log("CLICKED");
//     //     try {
//     //         const { data } = await axios.post(`${url}/billinfo`, {
//     //             bill_no: item.Bill,
//     //             Date: convertDate(item.Date),
//     //             Outlet_Name: selectedOutlet,
//     //             token: token,
//     //         });

//     //         if (data) {
//     //             setBillInfoList(data.details || []);
//     //             setBillInfo(data);
//     //             setShowModal(true);
//     //         }
//     //     } catch (error) {
//     //         console.log("Bill error", error);
//     //         toast.error(error?.response?.data?.error || "Failed to fetch data for the selected bill")
//     //     }
//     // };

//     return (
//         <div className="table-customer-history">
//             <DownloadTableExcel
//                 filename="customer_portal"
//                 sheet="CustomerHistory"
//                 currentTableRef={tableRef.current}>
//                 <button className="export">
//                     Export
//                 </button>
//             </DownloadTableExcel>
//             <div className='customer-table-title'>
//                 <h5>Customer History</h5>
//             </div>
//             <div className="table-history-responsive table-data-customer">
//                 <table className="table-customer" ref={tableRef}>
//                     <thead>
//                         <tr className='position-sticky'>
//                             <th>Bill</th>
//                             <th>Customer</th>
//                             <th>Date</th>
//                             <th>Discount Amount</th>
//                             <th>Discount Type</th>
//                             <th>Mode</th>
//                             <th>Total</th>
//                         </tr>
//                     </thead>
//                     {customerHistory.map((item, index) => (
//                         <tr key={item.idtblorderhistory || item.Bill || index}>
//                             <td >
//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         console.log(JSON.stringify(item))
//                                         handleBillInfo(item)
//                                         setBillID(item.idtblorderhistory)
//                                     }}
//                                 >
//                                     {item.Bill}
//                                 </button>
//                             </td>
//                             <td>{item.Customer}</td>
//                             <td>
//                                 <DateFormat date={item.Date} /></td>
//                             <td>{item.DiscountAmt}</td>
//                             <td>{item.DiscountType}</td>
//                             <td>{item.Mode}</td>
//                             <td>{item.Total}</td>
//                         </tr>
//                     ))
//                     }
//                     <tfoot>
//                         <tr>
//                             <td></td>
//                             <td></td>
//                             <td></td>
//                             <td>Discount: <span>{discountTotal}</span> </td>
//                             <td></td>
//                             <td></td>
//                             <td>Total: {totalSum}</td>
//                         </tr>
//                     </tfoot>
//                 </table>
//             </div>


//             {/* <BillDetail
//                 showModal={showModal}
//                 handleCloseModal={handleCloseModal}
//                 billInfo={billInfo}
//                 billInfoList={billInfoList}
//                 selected={selectedOutlet}
//             /> */}
//             <BillDetail
//                 showModal={showModal}
//                 handleCloseModal={handleCloseModal}
//                 data={billData}
//                 selected={selectedOutlet}
//                 billID={billID}
//             />
//         </div>
//     )
// }

// export default CustomerHistory









import React, { useRef, useState } from 'react'
import BillDetail from '../Modal/BillDetail';
import DateFormat from './DateFormat';
import axios from 'axios';
import { toast } from 'react-toastify';
import * as XLSX from "xlsx";
import { FaDownload, FaRegFileAlt } from "react-icons/fa";
import { FaCircleNotch } from "react-icons/fa6";
import { formatSalesValue } from '../../utils/formatUtils';
import { FiAlertCircle } from 'react-icons/fi';

const CustomerHistory = ({
    customerHistory,
    discountTotal,
    totalSum,
    selectedOutlet,
    url,
    token,
    loading,
    error,
    startDate,
    endDate,
}) => {
    const tableRef = useRef(null);

    const [billData, setBillData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [billID, setBillID] = useState();
    const [billLoading, setBillLoading] = useState({});

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const convertDate = (date) =>
        new Date(date).toLocaleDateString("en-CA");

    const handleBillInfo = async (item) => {
        const id = item.idtblorderhistory;

        setBillLoading(prev => ({
            ...prev,
            [id]: true,
        }));

        const payload = item.idtblorderhistory || item.idtblorderHistory
            ? {
                bill_id: item.idtblorderhistory || item.idtblorderHistory,
                Date: convertDate(item.Date),
                Outlet_Name: selectedOutlet,
                token,
            }
            : item.bill_id
                ? {
                    bill_id: item.idtblorderhistory,
                    Date: convertDate(item.Date),
                    Outlet_Name: selectedOutlet,
                    token,
                }
                : {
                    bill_no: item.bill_no,
                    Date: convertDate(item.Date),
                    Outlet_Name: selectedOutlet,
                    token,
                };

        try {
            const { data } = await axios.post(`${url}/billinfo`, payload);

            setBillData(data || []);
            setBillID(id);
            setShowModal(true);
        } catch (error) {
            const msg =
                error?.response?.data?.error ||
                "Failed to fetch bill details";

            toast.error(msg);
        } finally {
            setBillLoading(prev => ({
                ...prev,
                [id]: false,
            }));
        }
    };

    const handleExport = () => {
        const rows = [
            ["Customer History Report"],
            [`Date Range: ${startDate} - ${endDate}`],
            [],
            [
                "Bill",
                "Date",
                "Customer",
                "Discount",
                "Type",
                "Mode",
                "Total",
            ],
        ];

        customerHistory.forEach((item) => {
            rows.push([
                item.Bill,
                item.Date,
                item.Customer,
                item.DiscountAmt,
                item.DiscountType,
                item.Mode,
                item.Total,
            ]);
        });

        rows.push([
            "",
            "",
            "",
            discountTotal,
            "",
            "",
            totalSum,
        ]);

        const ws = XLSX.utils.aoa_to_sheet(rows);

        ws["!cols"] = [
            { wch: 15 },
            { wch: 18 },
            { wch: 25 },
            { wch: 15 },
            { wch: 18 },
            { wch: 18 },
            { wch: 15 },
        ];

        ws["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } },
        ];

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            "Customer History"
        );

        XLSX.writeFile(
            wb,
            `customer_history_${new Date()
                .toISOString()
                .split("T")[0]}.xlsx`
        );
    };

    if (error) {
        return (
            <div className="flex items-start justify-center gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-red-700 shadow-sm font-semibold">
                <FiAlertCircle className="h-6 w-6 flex-shrink-0" />

                <div>{error}</div>
            </div>
        )
    }

    return (
        <div className="flex flex-col max-h-full bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            {/* Table Header */}
            <div className="flex items-center justify-between px-4 py-2 border-b border-gray-100 bg-gray-50">
                <div className="text-sm font-semibold text-gray-700 tracking-wide uppercase">
                    Customer History
                </div>

                <button
                    onClick={handleExport}
                    className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-emerald-700 bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 rounded transition-colors"
                >
                    <FaDownload size={12} />
                    Export
                </button>
            </div>

            {/* Table */}
            <div className="overflow-auto flex-1 tiny-scrollbar max-h-[600px]">
                {loading ? (
                    <div className="flex flex-col items-center justify-center h-48 gap-3 text-gray-400">
                        <FaCircleNotch
                            className="animate-spin text-purple-400"
                            size={28}
                        />
                        <span className="text-sm">Loading history...</span>
                    </div>
                ) : customerHistory.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-48 gap-2 text-gray-400">
                        <FaRegFileAlt
                            size={40}
                            className="opacity-40"
                        />
                        <p className="text-sm">No records found</p>
                    </div>
                ) : (
                    <table className="w-full text-sm border-collapse text-center" ref={tableRef}>
                        <thead>
                            <tr className="bg-purple-50 text-purple-800 text-xs uppercase tracking-wide sticky top-0 z-10">
                                <th className="px-2 py-2.5 font-semibold border-b border-purple-100">Bill</th>
                                <th className="px-2 py-2.5 font-semibold border-b border-purple-100">Date</th>
                                <th className="px-2 py-2.5 font-semibold border-b border-purple-100">Customer</th>
                                <th className="px-2 py-2.5 font-semibold border-b border-purple-100">Discount</th>
                                <th className="px-2 py-2.5 font-semibold border-b border-purple-100">Type</th>
                                <th className="px-2 py-2.5 font-semibold border-b border-purple-100">Mode</th>
                                <th className="px-2 py-2.5 font-semibold border-b border-purple-100">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customerHistory.map((item, index) => (
                                <tr
                                    key={item.idtblorderhistory || item.Bill || index}
                                    className="hover:bg-purple-50/40 transition-colors border-b border-gray-100 last:border-0"
                                >
                                    <td className="p-2">
                                        <button
                                            type="button"
                                            disabled={billLoading[item.idtblorderhistory]}
                                            onClick={() => {
                                                setBillID(item.idtblorderhistory);
                                                handleBillInfo(item);
                                            }}
                                            className="text-purple-600 hover:text-purple-800 hover:underline font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                        >
                                            {billLoading[item.idtblorderhistory] ? (
                                                <FaCircleNotch
                                                    className="animate-spin"
                                                    size={14}
                                                />
                                            ) : item.Bill}
                                        </button>
                                    </td>
                                    <td className="p-2 text-gray-500 whitespace-nowrap">
                                        <DateFormat date={item.Date} />
                                    </td>
                                    <td className="p-2 text-gray-700">{item.Customer}</td>
                                    <td className="p-2 text-gray-700">{formatSalesValue(item.DiscountAmt)}</td>
                                    <td className="p-2 text-gray-500">{item.DiscountType}</td>
                                    <td className="p-2 text-gray-500">{item.Mode}</td>
                                    <td className="p-2 font-medium text-gray-800">{formatSalesValue(item.Total)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="bg-gray-50 border-t-2 border-gray-200 font-semibold text-gray-800 text-sm">
                                <td colSpan={3}></td>
                                <td className="p-2">
                                    {formatSalesValue(discountTotal)}
                                </td>
                                <td colSpan={2}></td>
                                <td className="p-2">
                                    {formatSalesValue(totalSum)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </div>

            <BillDetail
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                data={billData}
                selected={selectedOutlet}
                billID={billID}
            />
        </div>
    );
};

export default CustomerHistory;